<template>
  <div class="container">
    <van-nav-bar :border="false" left-arrow @click-left="$router.push('/')"></van-nav-bar>
    <div class="wrapper">
      <h3>短信登录</h3>
      <div class="form">
        <van-field v-model.trim="loginForm.mobile" :error-message="errMsg.mobile" @blur="checkMobile" placeholder="请输入手机号" />
        <van-field v-model.trim="loginForm.code" :error-message="errMsg.code" @blur="checkCode" placeholder="请输入验证码">
          <template #button ><span @click="send()" class="msg-btn">
            {{count===0?'发送验证码':`${count}秒后获取`}}
            </span></template>
        </van-field>
        <van-button type="primary" @click="login" block>登 录</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { login, send } from '@/api/user'
import { mapMutations } from 'vuex'
export default {
  name: 'UserLogin',
  data () {
    return {
      // 需要提交的数据
      loginForm: {
        mobile: '',
        code: ''
      },
      // 错误提示对象
      errMsg: {
        mobile: '',
        code: ''
      },
      // 计时
      count: 0
    }
  },
  methods: {
    send () {
      if (this.count === 0 && this.checkMobile() === undefined) {
        clearInterval(this.timer)
        send(this.loginForm.mobile).then(() => {
          this.count = 60
          this.timer = setInterval(() => {
            this.count--
            if (this.count <= 0) {
              clearInterval(this.timer)
            }
          }, 1000)
        })
      }
    },
    checkMobile () {
      // 1. 非空
      if (!this.loginForm.mobile) {
        // 错误提示
        this.errMsg.mobile = '请输入手机号'
        return false
      }
      // 2. 格式
      if (!/^1[3-9]\d{9}$/.test(this.loginForm.mobile)) {
        // 错误提示
        this.errMsg.mobile = '手机号格式错误'
        return false
      }
      // 3. 成功
      this.errMsg.mobile = ''
    },
    checkCode () {
      // 1. 非空
      if (!this.loginForm.code) {
        // 错误提示
        this.errMsg.code = '请输入验证码'
        return false
      }
      // 2. 格式
      if (!/^\d{6}$/.test(this.loginForm.code)) {
        // 错误提示
        this.errMsg.code = '验证码6个数字'
        return false
      }
      // 3. 成功
      this.errMsg.code = ''
    },
    ...mapMutations(['setUser']),
    async login () {
      // 整体表单校验
      this.checkMobile()
      this.checkCode()
      // 如何判断校验成功
      if (!this.errMsg.mobile && !this.errMsg.code) {
        // 校验成功
        // 1. 基于request封装登录的API
        // 2. 导入API
        // 3. 调用即可
        // 4. 获取用户信息
        // 5. 更新vuex中的user数据
        // 6. 根据地址栏进行跳转
        // 7. 提示 成功
        // 8. 失败 错误提示
        try {
          const data = await login(this.loginForm)
          // data  是对象  token  refresh_token
          this.setUser(data)
          this.$router.push(this.$route.query.redirectUrl || '/user')
          this.$toast.success('登录成功')
        } catch (e) {
          this.$toast.fail('用户名或验证码错误')
        }
      }
    }
  }
}
</script>

<style scoped lang='less'>
.van-nav-bar {
  height: 50px;
  ::v-deep .van-nav-bar__arrow {
    font-size: 20px;
    color: #999;
  }
}
.wrapper {
  padding: 0 32px;
  h3 {
    font-size: 24px;
    font-weight: normal;
    padding: 30px 0;
  }
  .form {
    padding: 32px 0;
    .van-cell {
      padding:20px 0;
    }
    .van-button {
      height: 50px;
      margin-top: 38px;
      border: none;
      background: linear-gradient(to right,#FE4F4F,#FC6627);
      font-size: 16px;
      &.disabled {
        background: linear-gradient(to right,#FF9999,#FFA179);
      }
    }
    ::v-deep .van-field__control {
      &::placeholder {
        font-size: 16px!important;
      }
    }
    .msg-btn {
      color: #999;
    }
  }
}

</style>
